export function TemplatesIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3 15a2 2 0 012-2h4a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4zM20.554 10.222l-6.913-2.033a.5.5 0 00-.641.48v7.32a.5.5 0 00.804.396l6.913-5.286a.5.5 0 00-.163-.877zM11 7a4 4 0 11-8 0 4 4 0 018 0z"
      ></path>
    </svg>
  );
}
